import { Injectable } from "@angular/core";
import { Socket, SocketIoConfig } from "ngx-socket-io";

export class Utils {

   /**
    * Funcion recursiva que transforma todos los datos en string que podrían
    * ser number. Es capaz de recibir todo tipo de variables
    * (array, objetos, ...)
    * @param data
    */

   transformStringToNumber( data ) {
      if ( data === null ) {
         return data;
      }

      switch ( typeof data ) {
         case "object":
            if ( Array.isArray(data) ) {
               data.map(item => item = this.transformStringToNumber(item));
            } else {
               Object.keys(data).map((key, index) => {
                  data[key] = this.transformStringToNumber(data[key]);
               });
            }

            return data;
         break;
         case "string":
            if ( data !== '' ) {
               data = !Number.isNaN(Number(data)) ? Number(data) : data;

               if (/((\d\d\d\d)-(\d\d)-(\d\d)) ((\d\d):(\d\d):(\d\d))*/.test(data)){
                  data = new Date(data);
               }
            }
            return data;
         break;
         default:
            return data;
         break;
      }
   }

 

   /**
    * Remapea el valor de un rango a otro
    * @param value
    * @param low1
    * @param high1
    * @param low2
    * @param high2
    */
   remap(value, low1, high1, low2, high2) {
      return low2 + (high2 - low2) * (value - low1) / (high1 - low1);
   }


   generateToken() {
      // Math.random should be unique because of its seeding algorithm.
      // Convert it to base 36 (numbers + letters), and grab the first 9 characters
      // after the decimal.
      return 't_' + Math.random().toString(36).substr(2, 10);
   };
}
